<mat-accordion>
  <mat-expansion-panel class="mat-elevation-z0 rounded-0" *ngFor="let accordionItem of list">
    <mat-expansion-panel-header [collapsedHeight]="collapsedHeight" [expandedHeight]="expandedHeight">
      <mat-panel-title>
        {{ accordionItem.header }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <p [innerHTML]="accordionItem.content"></p>
  </mat-expansion-panel>
</mat-accordion>
